import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import { routes } from './routes';
import BootstrapVue from 'bootstrap-vue';
import Store from './store/store';
import VModal from 'vue-js-modal';
import moment from 'moment';
import './components'
import vuelidate from 'vuelidate';

Vue.use(VueRouter);
Vue.use(BootstrapVue);
Vue.use(VModal);
Vue.use(vuelidate);

Vue.filter('date', function(value, format) {
	if (value) {
	  return moment(String(value)).format(format || 'DD/MM/YYYY');
	}
});

const router = new VueRouter({
  linkActiveClass: "active",
  routes: routes,
  mode: "history" //serve para tirar o hash da barra de endereco do navegador
});

new Vue({
  el: '#app',
  router: router,
  store: Store,
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js